"use client";

import Link from "next/link";

import type { HeaderProfileVariant } from "./types";

import ProfileButtonFramerComponent from "@/framer/header-navbar/profile-button";

export interface HeaderProfileButtonProps {
	variant?: HeaderProfileVariant;
	href?: string;
	ariaLabel?: string;
}

export function HeaderProfileButton({
	variant = "Variant 1",
	href = "/profilesettings",
	ariaLabel = "Profile",
}: HeaderProfileButtonProps) {
	return (
		<Link href={href} className="contents" aria-label={ariaLabel}>
			<ProfileButtonFramerComponent.Responsive variants={{ base: variant }} />
		</Link>
	);
}
